<div class="history">
  <div class="history__inner">
    <header class="history__head">
      <h1>Historique</h1>
      <p>Retrouvez vos transactions et paiements.</p>
    </header>

    <div class="history-state" *ngIf="loading">
      <mat-spinner diameter="36"></mat-spinner>
      <p>Chargement de l'historique…</p>
    </div>

    <div class="history-state history-state--error" *ngIf="!loading && errorMessage && !transactions.length">
      <mat-icon>error_outline</mat-icon>
      <p>{{ errorMessage }}</p>
      <button type="button" mat-stroked-button color="primary" (click)="reload()">Réessayer</button>
    </div>

    <ng-container *ngIf="!loading && !errorMessage">
      <section class="history-summary">
        <article class="summary-card">
          <mat-icon>check_circle</mat-icon>
          <div>
            <span>Complètes</span>
            <strong>{{ completedCount }}</strong>
          </div>
        </article>
        <article class="summary-card summary-card--accent">
          <mat-icon>pending</mat-icon>
          <div>
            <span>Incomplètes</span>
            <strong>{{ pendingCount }}</strong>
          </div>
        </article>
      </section>

      <div class="history-count">
        <span>{{ visibleTransactions.length }} transaction{{ visibleTransactions.length > 1 ? 's' : '' }}</span>
        <span>Total: {{ totalElements }}</span>
      </div>

      <label class="history-search">
        <mat-icon>search</mat-icon>
        <input
          type="search"
          [value]="searchQuery"
          (input)="onSearch($event)"
          placeholder="Rechercher une transaction..."
          aria-label="Rechercher une transaction" />
      </label>

      <div class="history-state" *ngIf="!visibleTransactions.length">
        <mat-icon>history</mat-icon>
        <p>Aucune transaction</p>
        <small>Actualisez pour recharger vos paiements.</small>
      </div>

      <article
        class="space-card"
        *ngFor="let tx of visibleTransactions"
        role="button"
        tabindex="0"
        (click)="openDetail(tx)"
        (keydown.enter)="openDetail(tx)"
        (keydown.space)="$event.preventDefault(); openDetail(tx)">
        <div class="space-card__top">
          <span class="space-card__icon" [ngClass]="typeClass(tx)">
            <mat-icon>{{ typeIcon(tx) }}</mat-icon>
          </span>
          <div class="space-card__copy">
            <strong>{{ sentenceCase(tx.description) }}</strong>
            <small>Opérateur: {{ providerName(tx) }}</small>
          </div>
          <span class="space-card__badge" [attr.data-tone]="statusTone(tx)">
            {{ statusLabel(tx) }}
          </span>
        </div>
        <div class="space-card__meta">
          <div>
            <span *ngIf="productName(tx) !== '-'">Produit: {{ productName(tx) }}</span>
            <strong>{{ formatCardDate(tx.createdAt) }}</strong>
          </div>
          <div class="space-card__meta-end">
            <strong>{{ formatAmount(tx) }}</strong>
          </div>
        </div>
      </article>

      <div class="history-state" *ngIf="loadingMore">
        <mat-spinner diameter="28"></mat-spinner>
      </div>
    </ng-container>
  </div>

  <div
    class="history-modal"
    *ngIf="selected as tx"
    (click)="closeDetail()"
    role="presentation">
    <div
      class="history-modal__panel"
      (click)="$event.stopPropagation()"
      role="dialog"
      aria-modal="true"
      aria-labelledby="history-modal-title">
      <header class="history-modal__head">
        <span class="space-card__icon history-modal__icon" [ngClass]="typeClass(tx)">
          <mat-icon>{{ typeIcon(tx) }}</mat-icon>
        </span>
        <h2 id="history-modal-title">{{ sentenceCase(tx.description) }}</h2>
      </header>

      <div class="history-modal__rows">
        <div class="history-modal__row">
          <span>Montant</span>
          <strong>{{ formatAmount(tx) }}</strong>
        </div>
        <div class="history-modal__row" *ngIf="!isComplete(tx)">
          <span>Statut de l'opération</span>
          <strong class="is-warn">{{ operationStatusLabel(tx) }}</strong>
        </div>
        <div class="history-modal__row">
          <span>Statut du paiement</span>
          <strong [attr.data-tone]="selectedPaymentStatus.tone">{{ selectedPaymentStatus.label }}</strong>
        </div>
        <div class="history-modal__row">
          <span>Opérateur</span>
          <strong>{{ providerName(tx) }}</strong>
        </div>
        <div class="history-modal__row">
          <span>{{ issuerLabel(tx) }}</span>
          <strong>{{ tx.accountNumber || '-' }}</strong>
        </div>
        <div class="history-modal__row">
          <span>{{ contractOrProjectLabel(tx) }}</span>
          <strong>{{ contractOrProjectValue(tx) }}</strong>
        </div>
        <div class="history-modal__row">
          <span>Produit</span>
          <strong>{{ productName(tx) | uppercase }}</strong>
        </div>
        <div class="history-modal__row">
          <span>Date</span>
          <strong>{{ formatDetailDate(tx.createdAt) }}</strong>
        </div>
        <div class="history-modal__row">
          <span>Référence</span>
          <strong>{{ (tx.reference || '-') | uppercase }}</strong>
        </div>
      </div>

      <button type="button" class="history-modal__close" (click)="closeDetail()">Fermer</button>
    </div>
  </div>
</div>
